import { render, staticRenderFns } from "./MaterialManagerView.vue?vue&type=template&id=130d79b9&scoped=true"
import script from "./MaterialManagerView.vue?vue&type=script&lang=js"
export * from "./MaterialManagerView.vue?vue&type=script&lang=js"
import style0 from "./MaterialManagerView.vue?vue&type=style&index=0&id=130d79b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d79b9",
  null
  
)

export default component.exports